import request from "@/common/request"
import { EtiquetaDePreco, FormEtiquetaDePreco, TamanhoDaEtiqueta } from "@/models/EtiquetaDePreco"
import { Page } from "@/models/Page"
import { AxiosRequestConfig } from "axios"

const PATH = '/etiquetas'

export const create = async (data: FormEtiquetaDePreco): Promise<EtiquetaDePreco> =>
	await request.post(`${PATH}`, data)

export const createTamanhoDeEtiqueta = async (tamanho: TamanhoDaEtiqueta): Promise<TamanhoDaEtiqueta> =>
	await request.post(`${PATH}/tamanho-etiqueta`, tamanho)

export const findTamanhoDeEtiqueta = async (params?: any, config?: AxiosRequestConfig): Promise<Page<TamanhoDaEtiqueta>> => 
	await request.get(`${PATH}/find-tamanhos`, {params, ...config})

export const updatetamanhoDaEtiqueta = async (tamanhoEtiquetaId: string, tamanho: TamanhoDaEtiqueta): Promise<TamanhoDaEtiqueta> =>
	await request.post(`${PATH}/atualiza-tamanho/${tamanhoEtiquetaId}`, tamanho)

export const findListaTamanhosDaEtiqueta = async (params?: any, config?: AxiosRequestConfig): Promise<TamanhoDaEtiqueta[]> => 
	await request.get(`${PATH}/listar-tamanhos`, {params, ...config})

export const findTamanhoEtiquetaById = async (tamanhoEtiquetaId: string, config?: AxiosRequestConfig): Promise<TamanhoDaEtiqueta> =>
	await request.get(`${PATH}/tamanho/${tamanhoEtiquetaId}`, {...config})

export const findProdutosNotaBySerieAndNnf = async (params: any, lojaId: string, fornecedorId: string): Promise<void> =>
	request.get(`${PATH}/${lojaId}/${fornecedorId}/buscarItensDaNota`, {
		params,
	})